// extracted by mini-css-extract-plugin
export var callCard = "_pp-0";
export var callMessageButton = "_pp-1";
export var helpIcon = "_pp-3";
export var helpIconContainer = "_pp-4";
export var verticalDivider = "_pp-2";